import { EngravingRequestDto } from "models/Engraving";

export async function fetchEngravingByUser(api: any) {
  const response = await api.get(`/api/engravings`);
  if (!response.ok) throw new Error("Failed to fetch engrave for user");
  return response.body;
}

export async function removeEngraving(api: any, engraveId: number): Promise<boolean> {
  try {
    const response = await api.delete(`/api/engravings/${engraveId}`);
    if (response.ok) {
      console.log(`engrave ${engraveId} removed successfuly.`);
      return true;
    }
    else return false;

  } catch (error) {
    return false;
  }
}

export async function upsertEngraving(api: any, engravingDto: EngravingRequestDto) {
  const response = await api.post(`/api/engravings/upsert`, engravingDto);
  if (!response.ok) throw new Error(`Engraving upsert failed with status ${response.status}`);
}